export default __webpack_public_path__ + "static/media/chromecast.ac1e0df5.svg";